module.exports = __webpack_public_path__ + "img/shopIndex-xiaochengxucode.02b8fbb3.png";